import { useEffect } from 'react';
import { ChannelTypeInternal, TariffKindInternal } from '../../../../../data-access/gql-types/graphql';
import { useGetTariffs } from '../../../api/tariffs/tariff.hooks';
import { useDevicesAndChannelsContext } from '../../../context/devices-and-channels';
import { ChannelMeterTypeOrUndefined } from '../../../types';
import { useTariffConfigurationContext } from '../context/tariff-configuration-context';

export const useMeterTariffPricesConfiguration = () => {
  const { channel } = useDevicesAndChannelsContext();
  const { data: allTariffs } = useGetTariffs(ChannelTypeInternal.Meter);
  const { formValues, selectedTariff, form } = useTariffConfigurationContext();

  const setDefaultForm = () => {
    if (!formValues.hoursRanges.length) {
      form.setValue('prices', [{ price: 0, pricingTier: 2 }]);
    } else {
      if (formValues.hoursRanges.find((x) => x.pricingTier === 3)) {
        form.setValue('prices', [
          { price: 0, pricingTier: 1 },
          { price: 0, pricingTier: 2 },
          { price: 0, pricingTier: 3 },
        ]);
      } else {
        form.setValue('prices', [
          { price: 0, pricingTier: 1 },
          { price: 0, pricingTier: 2 },
        ]);
      }
    }
  };

  useEffect(() => {
    if (!selectedTariff) return;

    if (selectedTariff?.includes('_DYNAMIC') || selectedTariff === TariffKindInternal.TauronG13S) {
      form.setValue('prices', []);
      return;
    }

    const tariffConfigurations = (channel?.data as ChannelMeterTypeOrUndefined)?.sharedChannelSettings
      ?.tariffConfigurations;

    if (tariffConfigurations?.length) {
      const savedData = tariffConfigurations.find((x) => x.tariff === selectedTariff);

      if (savedData) {
        form.setValue(
          'prices',
          savedData.prices.map((x) => ({ price: x.price, pricingTier: x.pricingTier })),
        );
      } else setDefaultForm();
    } else setDefaultForm();
  }, [allTariffs, channel?.data as ChannelMeterTypeOrUndefined, selectedTariff]);
};
